import { useNavigate } from "react-router-dom";
import {
  addStudent,
  assignTeacher,
  deleteClass,
  editClass,
  editIcon,
} from "../../asset";
import { popupNavigation } from "../../util/functions/UniversalFunctions";
import { ClassApiResponse } from "../../types/classesTypes";
import useConfirmToast from "../../util/hooks/useConfirmToast";
import classesApis from "../../api/classesApis";
import { toast } from "sonner"

interface Props {
  open: boolean;
  classData: ClassApiResponse;
  openAssignTeacherModal: () => void;
}

export default function ActionDropDown({
  open,
  classData,
  openAssignTeacherModal,
}: Props) {
  const navigate = useNavigate();
  const { confirm, modal } = useConfirmToast();

  const handleDelete = async () => {
    const confirmed = await confirm(
      "Are you sure you want to delete this class?",
    );

    if (!confirmed) return;
    try {
      const res = await classesApis.deleteClass(classData.classId);
      if (res?.status === 1) {
        toast.success("Class deleted successfully");
        navigate("/classes");
      }
    } catch (error) {
      console.error("Failed to delete class:", error);
    }
  };

  const menuItems = [
    {
      label: "Assign Teachers",
      icon: assignTeacher,
      link: openAssignTeacherModal,
    },
    {
      label: "Add Students",
      icon: addStudent,
      link: () => navigate(popupNavigation("addStudentToClass")),
    },
    {
      label: "Edit Class",
      icon: editClass,
      link: () =>
        navigate(popupNavigation("addClasses"), {
          state: { selectedClass: classData },
        }),
    },
    {
      label: "Delete Class",
      icon: deleteClass,
      danger: true,
      link: handleDelete,
    },
  ];

  return (
    <div
      className={`absolute right-0 mt-2 w-48 p-2 bg-white rounded-lg shadow-xl
      z-20 transition-all duration-200 
      ${open ? "opacity-100 visible" : "opacity-0 invisible"}`}
    >
      <ul className="flex flex-col gap-2 py-3 text-sm text-neutral-600 font-medium">
        {menuItems.map((item) => (
          <li
            key={item.label}
            onClick={() => item.link && item.link()}
            className={`px-4 py-2 cursor-pointer text-nowrap flex font-medium text-sm items-center gap-3 rounded-md hover:bg-background-300
            ${item.danger ? "text-error-600" : "text-neutral-600"}`}
          >
            <img
              src={item.icon}
              alt={item.label}
              className="w-[17px] h-[17px]"
            />
            <span>{item.label}</span>
          </li>
        ))}
      </ul>
      {modal}
    </div>
  );
}
